<template>
  <TheMenuLayout>
    <div v-if="lastSemester">
      <BaseSectionHeader>
        {{ $t('Last semester') }} - {{ lastSemester.semester }}
      </BaseSectionHeader>
      <v-row>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="accent lighten-3" :title="$t('General ranking')">
            <span v-if="lastSemester.rank">
              {{ lastSemester.rank }}/{{ lastSemester.number_of_students }}
            </span>
            <span v-else>NA</span>
          </BaseNumberCard>
        </v-col>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="accent lighten-3" :title="$t('Average mark')">
            <span v-if="lastSemester.average_mark">
              {{ lastSemester.average_mark.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
            </span>
            <span v-else>
              NA
            </span>
          </BaseNumberCard>
        </v-col>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="grey lighten-3" :title="$t('Max grade')">
            <span v-if="lastSemester.min_and_max.max">
              {{ lastSemester.min_and_max.max.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
            </span>
            <span v-else>
              NA
            </span>
          </BaseNumberCard>
        </v-col>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="grey lighten-3" :title="$t('Min grade')">
            <span v-if="lastSemester.min_and_max.min">
              {{ lastSemester.min_and_max.min.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
            </span>
            <span v-else>
              N/A
            </span>
          </BaseNumberCard>
        </v-col>
      </v-row>

      <v-divider class="mb-4" />

      <BaseSectionHeader>
        {{ $t('Progression') }}
      </BaseSectionHeader>

      <v-row class="d-lg-none">
        <v-col>
          <v-btn-toggle
            v-model="chartType"
            tile
            color="primary"
            group
          >
            <v-btn value="general">
              Générale
            </v-btn>

            <v-btn value="subjectBreakdown">
              Par matière
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="12">
          <v-card rounded outlined class="pa-4">
            <BaseMarksChart
              v-if="chartType === 'general'"
              :labels="generalProgressionChart.labels"
              :dataSets="generalProgressionChart.dataSets"
            />
            <BaseMarksChart
              v-else
              :labels="subjectProgressionChart.labels"
              :dataSets="subjectProgressionChart.dataSets"
            />
          </v-card>
        </v-col>
      </v-row>

      <v-row class="d-none d-lg-flex">
        <v-col cols="6">
          <v-card rounded outlined class="pa-4">
            <BaseMarksChart
              :labels="generalProgressionChart.labels"
              :dataSets="generalProgressionChart.dataSets"
            />
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card rounded outlined class="pa-4">
            <BaseMarksChart
              :labels="subjectProgressionChart.labels"
              :dataSets="subjectProgressionChart.dataSets"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
    <BaseEmptyState v-else>
      Vous n'avez pas encore de note enregistrée
    </BaseEmptyState>
  </TheMenuLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseNumberCard from '@/components/BaseNumberCard.vue';
import BaseMarksChart from '@/components/BaseMarksChart.vue';
import BaseEmptyState from '@/components/BaseEmptyState.vue';

export default {
  name: 'Progression',
  components: {
    BaseSectionHeader,
    TheMenuLayout,
    BaseNumberCard,
    BaseMarksChart,
    BaseEmptyState,
  },
  data() {
    return {
      chartType: 'general',
    };
  },
  created() {
    this.fetchProgression();
  },
  computed: mapGetters(['lastSemester', 'generalProgressionChart',
    'subjectProgressionChart']),
  methods: mapActions(['fetchProgression']),
};
</script>
